// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__zJ7yA","icon":"IconButton_icon__SQ3IH","text":"IconButton_text__qPYV+"};